export default __webpack_public_path__ + "static/media/screen_scrumweb.04c3ebef.png";